<app-page-header-job [isCurveGray]="true" header="{{language.jobdetailheader}}" backgroundPath="assets/images/lead/bg.jpg">
</app-page-header-job>

<div class="container mt-5">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
            <div class="col-lg-12 col-md-12 col-sm-12 d-flex">
                <div class="col-lg-10 col-md-10 col-sm-10 text-left p-0">
                    <h1>{{positionname}}</h1>
                </div>
                <div class="col-lg-2 col-md-2 col-sm-2 p-0" style="text-align:
                    -webkit-right;">
                    <app-button text="{{language.btn7}}" (click)="Detail(id)" class="float-right">
                        <button class="button--primary">
                            <span>
                                <a>Apply</a>
                            </span>
                        </button>
                    </app-button>
                </div>
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-4 p-0">
                <h2 class="text-left pl-3">{{language.jobdetailtitle1}}</h2>
                <div *ngIf="isUl;else elseUl" class="job-description text-left mt-1  pl-3" [innerHTML]="details_work"></div>
                <ng-template #elseUl>
                    <div class="job-description text-left mt-1  pl-4" [innerHTML]="details_work"></div>
                </ng-template>
                <!-- <p class="job-description text-left mt-3">{{details_work}}</p> -->
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-4 p-0">
                <h2 class="text-left  pl-3">{{language.jobdetailtitle2}}</h2>
                <div *ngIf="isSpecial;else elseSpecial" class="job-description text-left mt-1  pl-3" [innerHTML]="special"></div>
                <ng-template #elseSpecial>
                    <div class="job-description text-left mt-1  pl-4" [innerHTML]="special"></div>
                </ng-template>
                <!-- <div class="job-description text-left mt-1  pl-5" [innerHTML]="special"></div> -->
                <!-- <ul>
                    <li>
                        <p class="job-description-bullet text-left mt-3">คณะบริหารธุรกิจ
                            สาขาการบัญชีบริหาร สาขาบัญชี-การเงิน
                            หรือสาขาอื่นๆที่เกี่ยวข้อง</p>
                    </li>
                    <li>
                        <p class="job-description-bullet text-left mt-3">รับนักศึกษาจบใหม่</p>
                    </li>
                    <li>
                        <p class="job-description-bullet text-left mt-3">มีประสบการณ์ด้านบัญชี
                            วิเคราะห์งบการเงิน อย่างน้อย 6 เดือน ถึง 1 ปี</p>
                    </li>
                    <li>
                        <p class="job-description-bullet text-left mt-3">อายุ
                            21-26 ปี</p>
                    </li>
                </ul> -->
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-3 p-0">
                <h2 class="text-left pl-3">{{language.jobdetailtitle3}}</h2>
                <!-- <ul class="mt-3 p-0" style="list-style: none;">
                    <li class="m-0"> -->
                        <p class="company text-left mb-1 mt-2 pl-4">{{language.jobdetailaddress1}}</p>
                        <p class="job-contact2 text-left pl-4">{{language.jobdetailaddress2}}</p>
                        <p class="job-contact2 text-left pl-4">{{language.jobdetailaddress3}}</p>
                    <!-- </li>
                    <li class="mt-4"> -->
                        <p class="job-contact text-left mb-0 pl-4">{{language.jobdetailaddress4}}</p>
                    <!-- </li>
                    <li> -->
                        <p class="job-contact text-left mb-0 mt-0 pl-4">E-mail: hr@one-asset.com
                        </p>
                    <!-- </li> -->

                <!-- </ul> -->
            </div>

            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5 p-0">
                <div class="mapouter">
                    <div class="gmap_canvas">
                        <agm-map [latitude]="lat" [longitude]="lng" [scrollwheel]="false" [zoom]="17" [fullscreenControl]='true' [mapTypeControl]='true'>
                            <agm-marker [latitude]="lat" [longitude]="lng" [iconUrl]="'../../../assets/images/icon/pin-one.png'">
                            </agm-marker>
                        </agm-map>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-5 p-0">
                <app-button text="{{language.btn7}}" (click)="Detail(id)">
                    <button class="button--primary">
                        <span>
                            <a>Apply</a>
                        </span>
                    </button>
                </app-button>
            </div>

        </div>
    </div>
</div>